module.exports = __webpack_public_path__ + "img/tl.eee20265.jpg";